import React from "react";
import { motion } from "framer-motion";
import PageCover from "../Components/Shared/PageCover";
import coverInterior3 from "../Components/Assets/Images/coverInterior3.jpg";
import { Box, Typography, Button } from "@mui/material";
import { Container, Row, Col, Image } from "react-bootstrap";
import cityCollage from "../Components/Assets/Images/cityCollage2.png";

const About = () => {
  return (
    <>
      <motion.div
        initial={{ y: -100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 1.2, ease: "easeInOut" }}
      >
        <PageCover
          image={coverInterior3}
          title="About Us"
          subtitle="Learn More About Our Journey and Mission"
        />
      </motion.div>
      <Box style={{ backgroundColor: "#fffcfcd4", padding: "4rem 0" }}>
        <Container>
          <Row className="align-items-center">
            {/* Left Content */}
            <Col lg={6}>
              <motion.div
                initial={{ x: -100, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 1.2, ease: "easeInOut" }}
              >
                <Box className="mb-4 handpickText">
                  <Typography variant="h6">Our Vision & Mission</Typography>
                </Box>

                <Typography
                  variant="h4"
                  className="about-title"
                  sx={{
                    fontWeight: 700,
                    marginBottom: "20px",
                    fontSize: "45px",
                  }}
                >
                  Few Words About Our Work
                </Typography>

                <Typography
                  variant="body1"
                  sx={{
                    marginBottom: "16px",
                    textAlign: "justify",
                    fontSize: "18px",
                    color: "#464746",
                  }}
                >
                  We believe that air travel should not be a luxury reserved for
                  a few, but a possibility open to everyone. Our mission is to
                  make flying affordable, accessible, and transparent, so that
                  even a common man can experience the freedom of air travel. We
                  are here to break the long-standing notion that flights are
                  only meant for the upper class. Whether it’s a long-awaited
                  family visit, a quick business trip, or a dream vacation, we
                  help travelers find the most economical flight fares without
                  compromising on reliability or convenience. By focusing on
                  smart search, honest pricing, and user-first technology, we
                  make sure your journey begins with confidence.
                </Typography>

                <Typography
                  variant="body1"
                  sx={{
                    marginBottom: "30px",
                    fontSize: "18px",
                    color: "#464746",
                  }}
                >
                  At our core, we are building more than a travel platform. We
                  are building opportunities, opening skies, and turning
                  “someday” trips into today’s journeys.
                </Typography>
                <Box className="btnWrapper sliderBtn">
                  <Button
                    variant="link"
                    className="coverBtn bg-orange btnIcon D-font"
                    style={{ fontSize: "16px" }}
                  >
                    View Testimonials
                  </Button>
                </Box>
              </motion.div>
            </Col>

            {/* Right Image */}
            <Col lg={6}>
              <motion.div
                initial={{ x: 100, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 1.4, ease: "easeInOut" }}
                className="about-image-wrapper"
              >
                <Box className="serviceImg">
                  <Image src={cityCollage} className="img-fluid"></Image>
                </Box>
              </motion.div>
            </Col>
          </Row>
        </Container>
      </Box>
    </>
  );
};

export default About;
